<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar contas">
</app-toolbar-search>

<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="aoTrocarAba()" class="custom-tabview">
  <p-tabPanel *ngFor="let plano of groupByNatureza; let natureza = index" [header]="retornaNaturezaTexto(natureza)">
    <p-table #dt 
      [value]="plano" 
      [globalFilterFields]="['codigo', 'descricao', 'tipo', 'contaSuperior', 'nivel', 'saldo']"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      class="custom-table"
      [loading]="loading"
      [rowsPerPageOptions]="[5, 10, 20, 50]">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="codigo" style="width: 10%">
            Código <p-sortIcon field="codigo"></p-sortIcon>
          </th>
          <th pSortableColumn="descricao" style="width: 30%">
            Descrição <p-sortIcon field="descricao"></p-sortIcon>
          </th>
          <th style="width: 10%">
            <p-dropdown [options]="tiposContas" optionLabel="label" optionValue="value"
              [(ngModel)]="filtroTipoSelecionado" (onChange)="filtrarPorTipo()" placeholder="Tipo"
              styleClass="w-full"></p-dropdown>
          </th>
          <th pSortableColumn="contaSuperior" style="width: 15%">
            Conta Superior <p-sortIcon field="contaSuperior"></p-sortIcon>
          </th>
          <th pSortableColumn="nivel" style="width: 8%">
            Nível <p-sortIcon field="nivel"></p-sortIcon>
          </th>
          <th pSortableColumn="saldo" style="width: 12%">
            {{nomeColunaSaldo}} <p-sortIcon field="saldo"></p-sortIcon>
          </th>
          <th pSortableColumn="tipoTransacaoSaldoAnteriorCadastro" style="width: 10%">
            Natureza <p-sortIcon field="tipoTransacaoSaldoAnteriorCadastro"></p-sortIcon>
          </th>
          <th style="width: 5%">Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-contaContabil>
        <tr>
          <td>
            <div class="code-content">
              <i class="pi pi-tag code-icon"></i>
              <span class="code-text" [pTooltip]="contaContabil.codigo" tooltipPosition="top">{{ contaContabil.codigo }}</span>
            </div>
          </td>
          <td>
            <div class="description-content">
              <i class="pi pi-align-left description-icon"></i>
              <span class="description-text" [pTooltip]="contaContabil.descricao" tooltipPosition="top">{{ contaContabil.descricao }}</span>
            </div>
          </td>
          <td>
            <div class="type-content">
              <i class="pi pi-info-circle type-icon"></i>
              <span class="type-text" [pTooltip]="retornaTipo(contaContabil.tipo)" tooltipPosition="top">{{ retornaTipo(contaContabil.tipo) }}</span>
            </div>
          </td>
          <td>
            <div class="superior-content">
              <i class="pi pi-sort-up superior-icon"></i>
              <span class="superior-text" [pTooltip]="contaContabil.contaSuperior" tooltipPosition="top">{{ contaContabil.contaSuperior }}</span>
            </div>
          </td>
          <td>
            <div class="level-content">
              <i class="pi pi-sort-numeric-up level-icon"></i>
              <span class="level-text" [pTooltip]="'Nível: ' + contaContabil.nivel" tooltipPosition="top">{{ contaContabil.nivel }}</span>
            </div>
          </td>
          <td>
            <div class="balance-content">
              <i class="pi pi-dollar balance-icon"></i>
              <p-inputNumber 
                *ngIf="podeEditarSaldoNatureza(contaContabil)"
                [ngModel]="getValorEditavel(contaContabil)" 
                (ngModelChange)="onValorEditavelChange({value: $event}, contaContabil)"
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
                [style]="{'width': '100%'}"
                (onFocus)="salvarValorOriginal(contaContabil)"
              (onBlur)="confirmaAlteracao($event, contaContabil)"
                [pTooltip]="'Clique para editar o saldo'" 
                tooltipPosition="top">
            </p-inputNumber>
              <span *ngIf="!podeEditarSaldoNatureza(contaContabil)" 
                    class="balance-text" 
                    [pTooltip]="formatarValorExibicao(contaContabil.saldoAnteriorCadastro)" 
                    tooltipPosition="top">
                {{ formatarValorExibicao(contaContabil.saldoAnteriorCadastro) }}
              </span>
            </div>
          </td>
          <td>
            <div class="nature-content">
              <i class="pi pi-info-circle nature-icon"></i>
              <p-dropdown 
                [options]="naturezaSaldoOptions" 
                [(ngModel)]="contaContabil.tipoTransacaoSaldoAnteriorCadastro"
                optionLabel="nome" 
                optionValue="tipo"
                [style]="{'width': '100%'}"
                [disabled]="!podeEditarSaldoNatureza(contaContabil)"
                (onFocus)="salvarValorOriginal(contaContabil)"
                (onChange)="onNaturezaChange($event, contaContabil)"
                [pTooltip]="podeEditarSaldoNatureza(contaContabil) ? 'Selecione a natureza' : 'Natureza calculada automaticamente'" 
                tooltipPosition="top">
            </p-dropdown>
            </div>
          </td>
          <td class="text-center">
            <div class="actions-content">
            <button
                *ngIf="podeTerAcoes(contaContabil) && (contaContabil.maiorNivel || isContaOriginalNivelMaximo(contaContabil))"
                pButton pRipple icon="pi pi-plus" pTooltip="Adicionar Conta Contábil" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button"
                (click)="adicionarContaContabil(contaContabil)">
            </button>

              <button
                *ngIf="podeTerAcoes(contaContabil) && !contaContabil.maiorNivel && !isContaOriginalNivelMaximo(contaContabil) && !temContasFilhas(contaContabil)"
                pButton pRipple icon="pi pi-pencil" pTooltip="Editar Conta Contábil" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button"
              (click)="editarContaContabil(contaContabil)">
            </button>

              <button
                *ngIf="podeTerAcoes(contaContabil) && !contaContabil.maiorNivel && !isContaOriginalNivelMaximo(contaContabil) && !temContasFilhas(contaContabil)"
                pButton pRipple icon="pi pi-times" pTooltip="Excluir Conta Contábil" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button" severity="danger"
              (click)="excluirContaContabil(contaContabil?.id)">
            </button>
            </div>
          </td>
        </tr>
        
        <tr *ngIf="editandoNovaConta && contaPaiSelecionada?.id === contaContabil.id" class="nova-conta-row">
          <td>
            <div class="code-content">
              <i class="pi pi-hashtag code-icon"></i>
              <span class="code-text">{{ contaContabil.codigo }}.XX</span>
            </div>
          </td>
          <td>
            <div class="description-content">
              <i class="pi pi-align-left description-icon"></i>
              <input 
                pInputText 
                [(ngModel)]="novaConta.descricao"
                placeholder="Digite a descrição"
                [style]="{'width': '100%', 'padding': '0.5rem', 'border': '1px solid #ced4da', 'border-radius': '4px'}"
                [pTooltip]="'Descrição da nova conta'" 
                tooltipPosition="top">
            </div>
          </td>
          <td>
            <div class="type-content">
              <i class="pi pi-info-circle type-icon"></i>
              <span class="type-text">Analítico</span>
            </div>
          </td>
          <td>
            <div class="superior-content">
              <i class="pi pi-sort-up superior-icon"></i>
              <span class="superior-text">{{ contaContabil.contaSuperior }}</span>
            </div>
          </td>
          <td>
            <div class="level-content">
              <i class="pi pi-sort-numeric-up level-icon"></i>
              <span class="level-text">{{ contaContabil.nivel }}</span>
            </div>
          </td>
          <td>
            <div class="balance-content">
              <i class="pi pi-dollar balance-icon"></i>
              <p-inputNumber 
                [ngModel]="getValorEditavelNovaConta()"
                (ngModelChange)="novaConta.saldoAnteriorCadastro = $event"
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
                [style]="{'width': '100%'}"
                placeholder="0,00"
                [pTooltip]="'Saldo da nova conta'" 
                tooltipPosition="top">
              </p-inputNumber>
            </div>
          </td>
          <td>
            <div class="nature-content">
              <i class="pi pi-info-circle nature-icon"></i>
              <p-dropdown 
                [options]="naturezaSaldoOptions" 
                [(ngModel)]="novaConta.tipoTransacaoSaldoAnteriorCadastro"
                optionLabel="nome" 
                optionValue="tipo"
                [style]="{'width': '100%'}"
                placeholder="Selecione"
                [pTooltip]="'Natureza da nova conta'" 
                tooltipPosition="top">
              </p-dropdown>
            </div>
          </td>
          <td class="text-center">
            <div class="actions-content">
              <button
                pButton pRipple icon="pi pi-check" 
                pTooltip="Salvar" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button p-button-success"
                (click)="salvarNovaConta()">
              </button>
              <button
                pButton pRipple icon="pi pi-times" 
                pTooltip="Cancelar" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button p-button-danger"
                (click)="cancelarNovaConta()">
              </button>
            </div>
          </td>
        </tr>

        <tr *ngIf="editandoContaExistente && contaEmEdicao?.id === contaContabil.id" class="edicao-conta-row">
          <td>
            <div class="code-content">
              <i class="pi pi-hashtag code-icon"></i>
              <span class="code-text">{{ contaEmEdicao.codigo }}</span>
            </div>
          </td>
          <td>
            <div class="description-content">
              <i class="pi pi-align-left description-icon"></i>
              <input 
                pInputText 
                [(ngModel)]="contaEmEdicao.descricao"
                placeholder="Digite a descrição"
                [style]="{'width': '100%', 'padding': '0.5rem', 'border': '1px solid #007bff', 'border-radius': '4px'}"
                [pTooltip]="'Descrição da conta'" 
                tooltipPosition="top">
            </div>
          </td>
          <td>
            <div class="type-content">
              <i class="pi pi-info-circle type-icon"></i>
              <span class="type-text">{{ retornaTipo(contaEmEdicao.tipo) }}</span>
            </div>
          </td>
          <td>
            <div class="superior-content">
              <i class="pi pi-sort-up superior-icon"></i>
              <span class="superior-text">{{ contaEmEdicao.contaSuperior || '-' }}</span>
            </div>
          </td>
          <td>
            <div class="level-content">
              <i class="pi pi-sort-numeric-up level-icon"></i>
              <span class="level-text">{{ contaEmEdicao.nivel }}</span>
            </div>
          </td>
          <td>
            <div class="balance-content">
              <i class="pi pi-dollar balance-icon"></i>
              <p-inputNumber 
                [ngModel]="getValorEditavel(contaEmEdicao)"
                (ngModelChange)="onValorEditavelChange({value: $event}, contaEmEdicao)"
                mode="currency" 
                currency="BRL" 
                locale="pt-BR"
                [style]="{'width': '100%'}"
                placeholder="0,00"
                [pTooltip]="'Saldo da conta'" 
                tooltipPosition="top">
              </p-inputNumber>
            </div>
          </td>
          <td>
            <div class="nature-content">
              <i class="pi pi-info-circle nature-icon"></i>
              <p-dropdown 
                [options]="naturezaSaldoOptions" 
                [(ngModel)]="contaEmEdicao.tipoTransacaoSaldoAnteriorCadastro"
                optionLabel="nome" 
                optionValue="tipo"
                [style]="{'width': '100%'}"
                placeholder="Selecione"
                (onChange)="onNaturezaChange($event, contaEmEdicao)"
                [pTooltip]="'Natureza da conta'" 
                tooltipPosition="top">
              </p-dropdown>
            </div>
          </td>
          <td class="text-center">
            <div class="actions-content">
              <button
                pButton pRipple icon="pi pi-check" 
                pTooltip="Salvar" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button p-button-success"
                (click)="salvarEdicaoConta()">
              </button>
              <button
                pButton pRipple icon="pi pi-times" 
                pTooltip="Cancelar" tooltipPosition="top"
                class="mr-1 p-button-rounded action-button p-button-danger"
                (click)="cancelarEdicaoConta()">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="empty-message">
            <div class="empty-content">
              <i class="pi pi-chart-bar" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
              <h3>Nenhum plano de contas encontrado</h3>
              <p>Não há planos de contas cadastrados nesta categoria.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
</p-tabView>

<p-confirmDialog></p-confirmDialog>